import { render } from "./RequiredMark.vue?vue&type=template&id=538fa5f5&scoped=true&bindings={\"isRequired\":\"props\",\"isValid\":\"props\"}"
import script from "./RequiredMark.vue?vue&type=script&lang=js"
export * from "./RequiredMark.vue?vue&type=script&lang=js"

import "./RequiredMark.vue?vue&type=style&index=0&id=538fa5f5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-538fa5f5"

export default script